import { makeStyles } from 'tss-react/mui';

const useStylesPosters = makeStyles()((theme) => {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            opacity: '1',
            width: theme.spacing(10),
            position: 'relative',
            overflow: 'hidden',
            boxSizing: 'border-box',
        },
        textContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            height: '100%',
            width: '100%',
        },

        shapeBig: {
            fontSize: theme.spacing(8),
            display: 'flex',
            [theme.breakpoints.up('xl')]: {
                fontSize: theme.spacing(10),
            },
        },

        rootL: {
            width: theme.spacing(22),
            height: theme.spacing(11),
        },
        sizeBig: {
            width: theme.spacing(15),
            //height: theme.spacing(16),
            [theme.breakpoints.up('xl')]: {
                width: theme.spacing(18),
                // height: theme.spacing(18),
            },
        },

        sizeSmall: {
            width: theme.spacing(9),
            [theme.breakpoints.up('xl')]: {
                width: theme.spacing(11),
            },
        },
    };
});

export default useStylesPosters;
